module.exports = __webpack_public_path__ + "img/12.64cbf5c2.png";